import React from 'react';
import { AppStateProvider } from './contexts/AppStateContext';
import { UiProvider } from './contexts/UiContext';
import { AppShell } from './components/shell/AppShell';
interface AppProps {
  /** Vzorčna družina za predstavitev: Siter (prva družina) ali izmišljena družina B. Člana izbereš na zaslonu »Kdo si?«. */
  demoFamily?: 'siter' | 'kovac';
  /** Simulira telefon brez povezave – spremembe ostanejo »čaka na sinhronizacijo«. */
  offline?: boolean;
}
export function App({
  demoFamily = 'siter',
  offline = false
}: AppProps) {
  return <AppStateProvider familyId={demoFamily} offline={offline} data-id="element-0" data-mp="2mnne1xqjvzy4">
      <UiProvider data-id="element-1" data-mp="31bs11dwmyxmp">
        <AppShell data-id="element-2" data-mp="31c9tdzg6grpc" />
      </UiProvider>
    </AppStateProvider>;
}